import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Форматы реквизитов карточки партнера (ТОО, ИП, агент, самозанятый) */
export const PARTNER_IIN_PATTERN = /^\d{12}$/;
export const PARTNER_REG_CERT_PATTERN = /^\d{12}$/;
export const PARTNER_BIK_PATTERN = /^[A-Z0-9]{8}$/;
/** ИИК: KZ и 18 латинских букв/цифр (номер счета банка может содержать буквы) */
export const PARTNER_IIK_PATTERN = /^KZ[A-Z0-9]{18}$/;

/** Максимальные длины полей карточки партнера (бэкенд: PartnerCreateRequest / PartnerUpdateRequest) */
export const PARTNER_MAX_LENGTH = {
  legalAddress: 1000,
  bank: 255,
  legalName: 500,
  tradeName: 255,
  contactPhone: 50,
  contactEmail: 255,
  fullName: 500,
  identityDocumentNumber: 50,
  identityDocumentIssuer: 500,
} as const;

/** Имя, фамилия, email и телефон учетной записи (бэкенд: AgentAccountCreateRequest и пользователи B2B) */
export const ACCOUNT_NAME_MAX_LENGTH = 255;
export const ACCOUNT_EMAIL_MAX_LENGTH = 255;
export const ACCOUNT_PHONE_MAX_LENGTH = 50;
export const ACCOUNT_PASSWORD_MIN_LENGTH = 8;
export const ACCOUNT_PASSWORD_MAX_LENGTH = 100;

/** Сегодняшняя дата в формате input[type=date] (YYYY-MM-DD) по локальному времени */
export function todayIso(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Дата не позже сегодняшней (бэкенд: «должно содержать прошедшую дату или сегодняшнее число») */
export function notFutureDateValidator(control: AbstractControl<string>): ValidationErrors | null {
  const value = control.value;
  return value && value > todayIso() ? { futureDate: true } : null;
}

/** Не пустая строка после trim (Validators.required пропускает "   ") */
export function notBlankValidator(control: AbstractControl<string>): ValidationErrors | null {
  const value = control.value;
  return typeof value === 'string' && value.length > 0 && !value.trim() ? { required: true } : null;
}

export function sanitizeDigits(value: string): string {
  return value.replace(/\D/g, '');
}

function normalizeAlnumUpper(value: string): string {
  return value.replace(/\s+/g, '').toUpperCase();
}

/** ИИК: обязательный префикс KZ и 18 латинских букв/цифр */
export function normalizeIik(value: string): string {
  const upper = normalizeAlnumUpper(value);
  if (!upper) return '';

  // Keep only Latin letters and digits after the mandatory "KZ" prefix.
  let rest = upper;
  if (rest.startsWith('KZ')) {
    rest = rest.slice(2);
  } else if (rest.startsWith('K') || rest.startsWith('Z')) {
    rest = rest.slice(1);
  }
  rest = rest.replace(/[^A-Z0-9]/g, '');

  return `KZ${rest}`.slice(0, 20);
}

/** БИК: 8 латинских букв/цифр в верхнем регистре */
export function normalizeBik(value: string): string {
  return normalizeAlnumUpper(value).slice(0, 8);
}
